import type {
  NotificationPreferenceConfigDto,
  NotificationPreferencesConfigDto,
} from '@personnel/application/dtos/NotificationPreferencesDto';
import type { NotificationChannel, NotificationGroup } from '@personnel/domain/types';
import type { ApiNotificationPreferenceConfig } from '@personnel/infrastructure/api/types/NotificationPreferencesApiResponse';

/**
 * Maps one configuration entry, giving both channel lists a value.
 *
 * An absent list means "none", which is the reading the screen needs: no available channel is a
 * locked row, and no mandatory channel is an editable one.
 */
const mapConfigEntry = (entry: ApiNotificationPreferenceConfig): NotificationPreferenceConfigDto => ({
  notificationGroup: entry.notificationGroup as NotificationGroup,
  availableChannels: (entry.availableChannels ?? []) as ReadonlyArray<NotificationChannel>,
  mandatoryChannels: (entry.mandatoryChannels ?? []) as ReadonlyArray<NotificationChannel>,
});

export const mapApiNotificationPreferencesConfigToDto = (
  entries: ReadonlyArray<ApiNotificationPreferenceConfig>,
): NotificationPreferencesConfigDto => entries.map(mapConfigEntry);
